import React from 'react';
import { Tooltip as TippyTooltip, TooltipProps } from 'react-tippy';

export function Tooltip({ children, ...props }: TooltipProps & { children: React.ReactNode }) {
  return (
    <TippyTooltip arrow arrowSize="small" {...props}>
      {children}
    </TippyTooltip>
  );
}
